<button
  #trigger
  type="button"
  data-test="hub-sort-trigger"
  aria-haspopup="menu"
  [attr.aria-expanded]="menuOpen()"
  class="flex h-12 cursor-pointer items-center gap-2 rounded-md border bg-white pl-4 pr-2 text-variant-sm-medium transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
  [class]="menuOpen() ? 'border-blue-600 text-blue-600' : 'border-border text-gray-800 hover:bg-gray-100'"
  stchPopover
  stchPopoverTrigger="click"
  stchPopoverPlacement="bottomRight"
  [stchPopoverTemplate]="sortMenu"
  [stchPopoverShowUntil]="menuClose"
  (stchPopoverVisibleChange)="handleMenuVisibleChange($event)"
>
  <span data-test="hub-sort-label" class="max-w-60 truncate">{{ label() }}</span>
  <app-icon
    data-test="hub-sort-chevron"
    [name]="menuOpen() ? 'sapphire-chevron-up' : 'sapphire-chevron-down'"
    [size]="16"
  />
</button>

<ng-template #sortMenu>
  <app-entity-hub-sort-menu
    [value]="value()"
    [filters]="filters()"
    (sortChange)="handleSelect($event)"
    (filtersChange)="handleFiltersChange($event)"
    (tabOut)="handleMenuTabOut()"
  />
</ng-template>
